import React, { useEffect, useRef } from 'react';
import '../../../Static/priceinfo.css';
import ReactToPrint from 'react-to-print';

import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchMarerialInwardView } from '../../../Store/PHPSlice/MatStock';
import { Grid, Paper, Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';


const MatInwardView = () => {
  const componentRef = useRef(); // Ref for the component to be printed

  const { inwardNo, inwardType } = useParams();
  const dispatch = useDispatch();

  const pidata = useSelector(
    (state) => state.MatStockData.materialInwardView
  );

  useEffect(() => {
    if (inwardNo && inwardType) {
      dispatch(fetchMarerialInwardView({ inwardNo, inwardType }));
    }
  }, [dispatch, inwardNo, inwardType]);

  const data = Array.isArray(pidata?.data) ? pidata.data : [];

  const handlePrint = () => {
    window.print();
  };
  const totalQty = data.reduce(
    (sum, item) => sum + Number(item.totqty || 0),
    0
  );

  const totmtr = data.reduce(
    (sum, item) => sum + Number(item.totmtr || 0),
    0
  );

  const totalInches = data.reduce(
    (sum, item) => sum + Number(item.totinch || 0),
    0
  );

  const totinwqty = data.reduce(
    (sum, item) => sum + Number(item.inwpqty || 0),
    0
  );

  return (
    <Grid item xs={12}>
      <Paper style={{ padding: '3vh' }} ref={componentRef}>

        {/* ===== HEADER (NO PRINT) ===== */}
        <div >
          <h3 className="centered-heading">Material Inward Info</h3>
          <div className="dashed-line"></div>
        </div>

        {/* ===== DETAILS TABLE ===== */}


        <table
          style={{
            margin: '30px auto',
            width: '70%',
            fontSize: '15px',
            border: '1px solid #000'
          }}
        >
          <tbody>
            <tr>
              <td style={{ border: '1px solid #000', padding: '8px' }}>
                <b>Inward No</b>
              </td>
              <td style={{ border: '1px solid #000', padding: '8px' }}>
                {inwardNo}
              </td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #000', padding: '8px' }}>
                <b>Inward Type</b>
              </td>
              <td style={{ border: '1px solid #000', padding: '8px' }}>
                {inwardType}
              </td>
            </tr>
          </tbody>
        </table>
        <h4 style={{ marginLeft: '5%', color: 'green' }}>
          Inward Details
        </h4>
        <table
          className="table table-bordered"
          style={{ width: '90%', margin: '0 5%' }}
        >
          <thead style={{ background: '#d4edda' }}>
            <tr>
              <th>Sr.No.</th>
              <th>Firm</th>
              <th>Location</th>
              <th>Barcode</th>
              <th>Material Name</th>
              <th>M.Qty & Type</th>
              <th>P.P Qty & Type</th>
              <th>Inward Qty</th>
              <th>Total Qty</th>
              <th>Total Mtr</th>
              <th>Total Inch</th>
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((val, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{val.firmNm}</td>
                  <td>{val.locNm}</td>
                  <td>{val.barcode}</td>
                  <td>{val.materialNm}</td>
                  {/* <td>{val.pktqty}</td> */}
                  <td>{val.mqty} {" "}{val.mtype}</td>
                  <td>{val.perpktqty} {" "}{val.ptype}</td>
                  <td>{val.inwpqty}</td>
                  <td>{val.totqty}</td>
                  <td>{val.totmtr}</td>
                  <td>{val.totinch}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center' }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr style={{ fontWeight: 'bold', background: '#f1f1f1' }}>
              <td colSpan="7" style={{ textAlign: 'right' }}>
                <b> Total</b>
              </td>
              <td><b>{totinwqty}</b></td>
              <td><b>{totalQty}</b></td>
              <td><b>{totmtr}</b></td>
              <td><b>{totalInches.toFixed(2)}</b></td>
            </tr>
          </tfoot>
        </table>

        {/* ===== BOTTOM INFO TABLE ===== */}


        {/* ===== PRINT BUTTON (BOTTOM, NO PRINT) ===== */}
        <div
          className="no-print"
          style={{ textAlign: 'center', marginTop: '20px' }}
        >
          <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
            <ReactToPrint
              trigger={() => <Button variant="contained" color="primary">Print</Button>}
              content={() => componentRef.current}
            />
          </div>
        </div>

      </Paper>
    </Grid>
  );
};

export default MatInwardView;
